import api from "../api";
import StockAccessService from "../stock-access.service";

class ItemService {
  getList(dataForm) {
    return api.get("/merchant/item", { params: dataForm });
  }

  getAllItem(dataForm) {
    return api.post("/merchant/item/get-all", dataForm);
  }

  getMainItem(dataForm) {
    return api.post("/merchant/item/get-main-item", dataForm);
  }

  store(dataForm) {
    return api.post("/merchant/item", dataForm, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  addItemToCategory(dataForm) {
    return api.post("/merchant/item/category/add-item", dataForm);
  }

  addExistingItem(dataForm) {
    return api.post("/merchant/item/category/add-existing-item", dataForm);
  }

  attachModifier(dataForm) {
    return api.post("/merchant/item/attach-modifier", dataForm);
  }

  handleEnableOrDisable(dataForm) {
    return api.post("/merchant/item/enable-or-disable", dataForm);
  }

  handleEnableOrDisableByMenuset(dataForm) {
    return api.post("/merchant/item/enable-or-disable-by-menuset", dataForm);
  }

  handleEnableOrDisableAll(dataForm) {
    return api.post("/merchant/item/enable-or-disable-all", dataForm);
  }

  handleEnableOrDisableAllByMenuset(dataForm) {
    return api.post("/merchant/item/enable-or-disable-all-by-menuset", dataForm);
  }

  // M886 - bulk price update
  bulkPreview(dataForm) {
    return api.post("/merchant/item/bulk/preview", dataForm);
  }

  bulkApply(dataForm) {
    return api.post("/merchant/item/bulk/apply", dataForm);
  }

  bulkHistory(dataForm) {
    return api.post("/merchant/item/bulk/history", dataForm);
  }

  bulkDetail(dataForm) {
    return api.post("/merchant/item/bulk/detail", dataForm);
  }

  bulkRevert(dataForm) {
    return api.post("/merchant/item/bulk/revert", dataForm);
  }

  // M892 - drops a temporary run booked for a later time, before it has moved
  // a single price
  bulkCancel(dataForm) {
    return api.post("/merchant/item/bulk/cancel", dataForm);
  }

  getMenuSetDropdown() {
    return api.post("/merchant/item/get-menu-set-dropdown");
  }

  update(id, dataForm) {
    return api.post("/merchant/item/update-item-list/"+id, dataForm, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  deleteItem(id) {
    return api.delete("/merchant/item/" + id);
  }

  itemDetail(id, dataForm = {}) {
    return api.get("/merchant/item/" + id, { params: dataForm });
  }

  moveUpDown(dataForm) {
    return api.post("/merchant/item/move-up-down", dataForm);
  }

  createCombo(dataForm) {
    return api.post("/merchant/item/create-combo", dataForm, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  comboDetail(id) {
    return api.post("/merchant/item/detail-combo/" + id);
  }

  updateCombo(id, dataForm) {
    return api.post("/merchant/item/update-combo/" + id, dataForm, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  handleAvailable(dataForm) {
    return api.post("/merchant/item/handle-available", dataForm);
  }

  getReportGroup() {
    return api.post("/merchant/item/get-report-group");
  }

  getListTag() {
    return api.post("/merchant/item/get-tag");
  }

  getAllStockItems(dataForm) {
    return api.get("/merchant/item/get-all-stock-items", { params: dataForm });
  }

  getAllStockItemsByPhysicalBranch(dataForm) {
    return api.get("/merchant/item/get-all-stock-items-by-physical-branch", {
      params: dataForm,
      ...StockAccessService.requestConfig(dataForm),
    });
  }

  getCategoryByMenuSetDropdown(dataForm) {
    return api.post("/merchant/item/get-category-by-menu-set-dropdown", dataForm);
  }

  updateStockBalanceByItem(dataForm) {
    return api.post("/merchant/item/update-stock-balance-by-item", dataForm, StockAccessService.requestConfig(dataForm));
  }

  handleEnableOrDisableAvailable(dataForm) {
    return api.post("/merchant/item/enable-or-disable-available", dataForm, StockAccessService.requestConfig(dataForm));
  }

  handleEnableOrDisableAvailableAll(dataForm) {
    return api.post("/merchant/item/enable-or-disable-available-all", dataForm, StockAccessService.requestConfig(dataForm));
  }
  
  checkPasscodeStockPage(dataForm) {
    return api.post("/merchant/check-passcode-stock-page", dataForm);
  }

  checkStockPasscodeExists(dataForm) {
    return api.post("/merchant/check-stock-passcode-exists", dataForm);
  }

  handleStockOnOff(dataForm) {
    return api.post("/merchant/item/stock-on-off", dataForm, StockAccessService.requestConfig(dataForm));
  }

  updateAutoResetStock(dataForm) {
    return api.post("/merchant/physical-branch/update-auto-reset-stock", dataForm, StockAccessService.requestConfig(dataForm));
  }

  getDataFilter(dataForm) {
    return api.post("/merchant/item/get-data-filter", dataForm);
  }
}

export default new ItemService();
